module.exports = __webpack_public_path__ + "img/logo_vov.ea11a166.png";